import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';
import type { ColumnEntityState } from '../../reducers/entities/column/types';
import type { State } from '../../types';
import { getEntities } from '../entities';

export const getColumns = (state: State) => getEntities(state).column;

export const makeGetColumn = (state: State) => (columnId: number) => {
	const columns = getColumns(state);
	if (!columns) {
		return null;
	}
	return columns[String(columnId)] ?? null;
};

export const findColumnByStatusId = (columns: ColumnEntityState, statusId: string) =>
	columns &&
	Object.values(columns).find((column) =>
		column.statuses.some((columnStatus) => columnStatus.id === statusId),
	);

export const getColumnByStatusId = createSelector([getColumns], (columns) =>
	memoize((statusId: string) => findColumnByStatusId(columns, statusId)),
);

export const getColumnCount = (columns: ColumnEntityState) => {
	if (!columns || Object.keys(columns).length === 0) {
		return { initialColumnCount: 0, inProgressColumnCount: 0, doneColumnCount: 0 };
	}

	// the order of columns in the state is not guaranteed so if you want to get the correct column object you will need to sort them by tje column's "order"
	const cols = Object.values(columns);
	const initialColumnCount = 1;
	const doneColumnCount = cols.length > 1 ? 1 : 0;
	const inProgressColumnCount = Math.max(0, cols.length - 2); // columns between initial and done

	return { initialColumnCount, inProgressColumnCount, doneColumnCount };
};
